import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';
import { REDCRSS_EVENTS } from '../../../../../../shared/services/constants/redcross_evemts';

@Component({
  selector: 'yi-add-yotpo-javascript',
  template: require('./shopify_add_javascript.component.html'),
  styles: [require('./shopify_add_javascript.component.scss')]

})

export class ShopifyAddJavascriptComponent extends AccordionContentComponent {

  navigateToThemeLiquid() {
    this.redcrossService.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'URL',
      ctaLocation: this.translatedTitle(this.item),
      ctaURL: this.item.getData().themeLiquid
    });
    this.redirectService.redirectTo(this.item.getData().themeLiquid, true);
  }
}
